<template>
  <div>
    <div>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousFFView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2>Handover to Rail</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s">
        <div class="phone-viewport" id="vehicleBooking">
          <md-list>
            <md-list-item
              id="showVisibility"
              class="md-button-color-toggle"
              v-bind:class="handover.conhandoverToRailId==''?'md-active':''"
              @click="showOverflow"
            >
              <span>Handover to Rail</span>

              <md-list-expand>
                <md-list>
                  <hr class="hr-border">

                  <md-layout md-gutter style="margin-top:2%">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <h3 style="margin-top:0px">
                        <u>Handover Party</u>
                      </h3>
                      <span class="error" v-if="!handover.handoverTo">{{errorList.handoverTo}}</span>
                    </md-layout>

                    <md-layout md-flex="20">
                      <md-radio
                        id="permitted"
                        name="permitted1"
                        md-value="HandOverToConcor"
                        v-model="handover.handoverTo"
                        class="md-primary margn-0px"
                      >HandOver To Concor</md-radio>
                    </md-layout>

                    <md-layout md-flex="15">
                      <md-radio
                        id="permitted2"
                        name="permitted2"
                        v-model="handover.handoverTo"
                        md-value="HandOverToCFS"
                        class="md-primary margn-0px"
                      >HandOver To CFS</md-radio>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <label>Handover Date</label>
                      <date-picker lang="en" v-model="handover.handoverDate" id="date"></date-picker>
                      <span class="error" v-if="!handover.handoverDate">{{errorList.handoverDate}}</span>
                    </md-layout>
                  </md-layout>
                  <md-card
                    style="margin-top:2%;margin-bottom:2%;overflow:visible;margin-left:15%;width:70%"
                    v-if="isPridel=='Pridel'"
                  >
                    <md-card-content>
                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="90">
                          <h5>Payment Details For Payment done Through Pridel PDA</h5>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="30">
                          <md-layout md-flex="100">
                            <label>Shipping Bill No</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="shippingBillNo"
                              name="shippingBillNo"
                              v-model="handover.shippingBillNo"
                            ></b-form-input>
                          </md-layout>
                          <span
                            class="error"
                            v-if="!handover.shippingBillNo && isPridel=='Pridel'"
                          >{{errorList.shippingBillNo}}</span>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="30">
                          <md-layout md-flex="100">
                            <label>Receipt No</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="receiptNo"
                              name="receiptNo"
                              v-model="handover.receiptNo"
                            ></b-form-input>
                          </md-layout>
                          <span
                            class="error"
                            v-if="!handover.receiptNo && isPridel=='Pridel'"
                          >{{errorList.receiptNo}}</span>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Ammount Paid (In Rs)</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="ammountPaid"
                              name="ammountPaid"
                              v-model="handover.ammountPaid"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <h4>Date Of Payment :</h4>
                        </md-layout>
                        <md-layout md-flex="10"></md-layout>
                        <md-layout md-flex="20">
                          <h4>Time Of Payment :</h4>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <date-picker lang="en" v-model="handover.paymentDate" id="date"></date-picker>
                          <span
                            class="error"
                            v-if="!handover.paymentDate && isPridel=='Pridel'"
                          >{{errorList.paymentDate}}</span>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <DatePicker
                            v-model="handover.paymentTime"
                            lang="en"
                            type="time"
                            format="HH:mm"
                            placeholder="Select Time"
                            :minute-step="1"
                          ></DatePicker>
                        </md-layout>
                        <md-layout md-flex="10"></md-layout>
                        <!-- <md-layout md-flex="30">
                          <md-button
                            class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
                            id="addButtonLoaderAcc"
                          >Submit To Accounts</md-button>
                          <md-spinner md-indeterminate id="loaderAcc" style="display:none"></md-spinner>
                        </md-layout>-->
                      </md-layout>
                    </md-card-content>
                  </md-card>
                  <hr class="hr-border">
                  <md-layout md-gutter>
                    <md-layout md-flex="40"></md-layout>
                    <md-layout md-flex="40">
                      <md-button
                        class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
                        id="addButtonLoader223"
                        @click="addHandoverToRail"
                        style="z-index:0"
                      >Proceed To Rail Out</md-button>
                      <md-spinner md-indeterminate id="loader223" style="display:none"></md-spinner>
                    </md-layout>
                  </md-layout>
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>

        <hr class="hr-s">
        <!-- <div class="phone-viewport" id="railOut" > -->
        <div class="phone-viewport" id="railOut" v-if="handover.conhandoverToRailId!=''">
          <md-list>
            <md-list-item
              id="showvehicleBooking"
              class="md-button-color-toggle md-active"
              style="overflow:visible"
            >
              <span>Rail Out</span>

              <md-list-expand>
                <md-list>
                  <hr class="hr-border">
                  <!-- <div v-if="getContainerNoData.length > 0 || railout.railOutTableId!=''"> -->
                  <div>
                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Container No</label>
                          <b-form-input :formatter="capitalizeAll" v-model="railout.containerNo" disabled></b-form-input>
                        </md-layout>
                        <span class="error" v-if="!railout.containerNo">{{errorRail.containerNo}}</span>
                      </md-layout>
                      <md-layout md-flex="10"></md-layout>
                      <md-layout md-flex="20">
                        <md-layout md-flex="100">
                          <label>Train No</label>
                          <b-form-input :formatter="capitalizeAll" id="trainNo" name="trainNo" v-model="railout.trainNo"></b-form-input>
                        </md-layout>
                        <span class="error" v-if="!railout.trainNo">{{errorRail.trainNo}}</span>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <md-layout md-flex="100">
                          <label>Wagon No</label>
                          <b-form-input :formatter="capitalizeAll" id="wagonNo" name="wagonNo" v-model="railout.wagonNo"></b-form-input>
                        </md-layout>
                        <span class="error" v-if="!railout.wagonNo">{{errorRail.wagonNo}}</span>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="45"></md-layout>
                      <md-layout md-flex="20">
                        <label>Train Departure Date</label>
                        <date-picker
                          v-model="railout.trainDepartDate"
                          lang="en"
                          type="datetime"
                          format="YYYY-MM-DD hh:mm a"
                          :minute-step="1"
                        ></date-picker>
                        <span
                          class="error"
                          v-if="!railout.trainDepartDate"
                        >{{errorRail.trainDepartDate}}</span>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <label>Train Arrival Date At Port</label>
                        <date-picker
                          lang="en"
                          v-model="railout.trainArriveDate"
                          type="datetime"
                          format="YYYY-MM-DD hh:mm a"
                          :minute-step="1"
                        ></date-picker>
                        <span
                          class="error"
                          v-if="!railout.trainArriveDate"
                        >{{errorRail.trainArriveDate}}</span>
                      </md-layout>
                    </md-layout>

                    <hr class="hr-border">
                    <md-layout md-gutter class="mrgtop-button">
                      <md-layout md-flex="40"></md-layout>
                      <md-layout md-flex="35">
                        <md-button
                          class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
                          id="addButtonLoaderRail"
                          @click="addRailOut"
                        >Proceed to Sail and FPOD</md-button>
                        <md-spinner md-indeterminate id="loaderRail" style="display:none"></md-spinner>
                      </md-layout>
                    </md-layout>
                  </div>

                  <hr class="hr-s">
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopData"
      @close="ProceedSail"
    ></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop11212"
      @close="onClose11212"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE } from "../../helper/constant.js";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editffConExecutionId") != undefined &&
      this.$sessionsStorage.get("editffConExecutionId") != ""
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/ffExportCon/fclConsoHandOverToRail"
      );
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {
    // handover: {
    //   handler: function(newVal, oldVal) {
    //    console.log("Here Change obj", newVal, oldVal)
    //     // this.handover.clientId=newVal.clientId;
    //   //  console.log(this.handover.clientId)
    //   },
    //   deep: true
    // },
  },
  data() {
    return {
      isLoading: false,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },

      handover: {
        conhandoverToRailId: "",
        conrailOutId: "",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        handoverTo: "",
        handoverDate: "",
        shippingBillNo: "",
        receiptNo: "",
        ammountPaid: "",
        paymentDate: "",
        paymentTime: "",
        stuffingType: ""
      },
      errorList: {
        handoverTo: "",
        handoverDate: "",
        shippingBillNo: "",
        paymentDate: "",
        receiptNo: ""
      },
      railout: {
        railOutTableId: "",
        conrailOutId: "",
        conhandoverToRailId: this.$sessionsStorage.get(
          "editconhandoverToRailId"
        ),
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),

        containerNo: "",
        trainDepartDate: "",
        trainNo: "",
        wagonNo: "",
        trainDepartTime: "",
        trainArriveDate: ""
      },
      ffConExectionData: [],
      removerailoutVmodel: {
        railOutTableId: "",

        containerNo: ""
      },
      errorRail: {
        trainNo: "",
        wagonNo: "",
        trainArriveDate: "",
        trainDepartDate: ""
      },

      arrayRailError: [
        "Select Container No",
        "Enter train No",
        "Enter wagon No",
        "Select Arrival Date",
        "Select Departure Date"
      ],
      stuffingType: "",
      railoutMain: {
        ffRailOutId: "",
        railOutTableId: "",
        handoverToRailId: "",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        stuffingType: ""
      },
      railOutTableArray: [],
      deleteId: "",
      showVisible: false,

      transhipmentArray: [],
      getPortData: ["Agra"],
      // clientName: "",
      // vehicleName: "",
      // driverId: "",
      // driverName: "",
      // driverContact: "",
      // driverWorkingYear: "",
      // driverEsic: "",
      // accountNo: "",
      // uploadDriverDoc: ""
      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: ""
      },
      getContainerNoData: [],
      isPridel: "",
      getCLientData: ["gfdg"],
      showSegmentArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New"
      },
      commodityListName: [],
      getShippingLineData: ["zim"],
      getlocationListData: ["agra"],
      validate: true,
      validateRail: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: ""
    };
  },

  mounted() {},
  beforeDestroy() {
    // this.$sessionsStorage.set("editExportFCLId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
     CustomLoader,
  },
  computed: {
    railOutTableArrayList() {
      return this.railOutTableArray;
    },
    containerNoList() {
      return this.getContainerNoData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.handover.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.commodityListName;
    }
  },
  methods: {
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    routePage() {
      this.$router.push({
        path: "/ffExportCon/consoFclSailFpod"
      });
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_railouttable",
          tableId: "railOutTableId",
          isActive: "isRailTableActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            this.getData();
            this.deleteId = "";
          })
          .catch(error => {});
      }
    },
    // getClientData1(item) {
    //   this.handover.clientId = item.clientId;
    //  // console.log(item)
    // },
    getPortId1(item) {
      this.handover.toportId = item.portId;
    },
    getPortId2(item) {
      this.handover.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    JqueryFun() {
      //   return $(function() {
      //     return $("#railOuttariff").DataTable();
      //   });
    },
    clientFilter(list, query) {
      return this.getCLientData.filter(x => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    ProceedSail() {
      this.$router.push({
        path: "/ffExportCon/consoFclSailFpod"
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter(x => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    validateFFExport() {
      let validate_new = true;

      if (this.handover.handoverTo == "") {
        $("#handoverTo").focus();
        this.errorList.handoverTo = "Please Select Handover";
        validate_new = false;
      }

      if (this.handover.handoverDate == "") {
        $("#handoverDate").focus();
        this.errorList.handoverDate = "Please Select Handover Date";
        validate_new = false;
      }

      if (this.handover.shippingBillNo == "" && this.isPridel == "Pridel") {
        $("#shippingBillNo").focus();
        this.errorList.shippingBillNo = "Please Enter Shipping Bill No";
        validate_new = false;
      }

      if (this.handover.receiptNo == "" && this.isPridel == "Pridel") {
        $("#receiptNo").focus();
        this.errorList.receiptNo = "Please Enter Receipt  No";
        validate_new = false;
      }

      if (this.handover.paymentDate == "" && this.isPridel == "Pridel") {
        this.errorList.paymentDate = "Please Select Payment Date";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    editRailTable(item) {
      let array = this.railOutTableArray.filter(x => {
        return x.railOutTableId == item.railOutTableId;
      });
      Object.keys(this.railout).map(x => {
        this.railout[x] = array[0][x] || "";
      });
    },
    addHandoverToRail() {
      this.validateFFExport();
      if (this.validate != false) {
        $("#addButtonLoader223").css("display", "none");
        $("#loader223").css("display", "block");

        // console.log(this.handover);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConsoHandoverRail.php`,
          data: JSON.stringify(this.handover),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if ( status == 200 && data) {
              this.handover.conFclBookingId = data.conhandoverToRailId;
              $("#loader223").css("display", "none");
              $("#addButtonLoader223").css("display", "block");
              if (this.handover.conhandoverToRailId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },
    addRailOut() {
      this.validateRail1();
      if (this.validateRail != false) {
        $("#addButtonLoaderRail").css("display", "none");
        $("#loaderRail").css("display", "block");

        // console.log(this.handover);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConsoRailOut.php`,
          data: JSON.stringify(this.railout),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if ( status == 200 && data) {
              this.railout.conrailOutId = data.conrailOutId;
              $("#loaderRail").css("display", "none");
              $("#addButtonLoaderRail").css("display", "block");
              if (this.railout.conrailOutId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.$refs["addPopData"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },
    showOverflow() {
      if (this.showVisible == false) {
        this.showVisible = true;
        $("#showVisibility").css("overflow", "visible");
      } else {
        this.showVisible = false;
        $("#showVisibility").css("overflow", "hidden");
      }
    },

    onClose11212() {
      if (this.stuffingType == "factoryStuffing") {
        this.$router.push({
          path: "/freightForward/ffExecution"
        });
      } else {
        this.$router.push({
          path: "/freightForward/ffexecutionWareHouse"
        });
      }
    },
    showSailFPOD() {
      this.$router.push({
        path: "/freightForward/sailFPOD"
      });
    },
    validateTranshipment() {
      let validate_new = true;

      if (this.transhipment.tentPortName == "") {
        $("#tentPortName").focus();
        this.error.tentPortNameError = "Enter Tentative Port Name";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    validateRail1() {
      let validate_new = true;
      Object.keys(this.errorRail).map((x, index) => {
        if (this.railout[x] == "") {
          this.errorRail[x] = this.arrayRailError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateRail = false;
      } else {
        this.validateRail = true;
      }
    },

    onClose22() {
      // this.railOutTableArray = [];
      // let payload = {
      //   railOutTableId: this.railoutMain.railOutTableId
      // };
      // if (this.railoutMain.ffRailOutId != "") {
      //   payload["ffRailOutId"] = this.railoutMain.ffRailOutId;
      // } else {
      //   payload["ffRailOutId"] = "";
      // }
      // let options = {
      //   method: "POST",
      //   url: `${URL_BASE}/Api_FFSeaExport/viewRailOutTable.php`,
      //   data: JSON.stringify(payload),
      //   crossDomain: true,
      //   headers: {
      //     Accept: "application/json",
      //     "Content-Type": "application/json",
      //     Authorization: this.$sessionsStorage.get("loginId")
      //   }
      // };
      // axios(options)
      //   .then(result => {
      //     const { statusText, status, data } = result;
      //     if ( status == 200 && data) {
      //       if (data.railOutTableData.length > 0) {
      //         this.railOutTableArray = data.railOutTableData;
      //       }
      //       //this.JqueryFun();
      //       // this.$refs["addPop1"].close();
      //       // this.itemModal = "";
      //       this.getData();
      //     }
      //   })
      //   .catch(error => {});
    },
    getData() {
      this.doLoading();
      this.railOutTableArray = [];
      let vehicle_drive = {
        containerNo: "containerNo",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchConHandoverToRail.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data, "sasasasa");
            if (data.FullwhExecData.length > 0) {
              this.ffConExectionData = data.FullwhExecData;
              let arrayContainer = this.ffConExectionData.filter(x => {
                return x.ffConExecutionId;
              })[0];
              this.railout.containerNo = arrayContainer.fclConcontainerNo;
            }

            if (data.handOverDetail.length > 0) {
              Object.keys(this.handover).map(x => {
                this.handover[x] = data.handOverDetail[0][x] || "";
              });
            } else {
              this.showVisible = true;
              $("#showVisibility").css("overflow", "visible");
            }

            if (data.railDetailData.length > 0) {
              Object.keys(this.railout).map(x => {
                this.railout[x] = data.railDetailData[0][x] || "";
              });
            }

            this.JqueryFun();
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient"
      });
    },
    deleteData(item) {
      this.deleteId = item.railOutTableId;

      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    previousFFView() {
      // console.log(this.handover);
      // return false;

      this.$router.push({
        path: "/ffExportCon/executionWHStuffingIcdCon"
      });
    },
    getServicesData() {
      this.showSegmentArray = [
        {
          value: "Freight_Forwarding",
          show: "Freight Forwarding(FF)",
          flex: "20"
        },
        {
          value: "Customs_Clearance",
          show: "Customs Clearance(CC)",
          flex: "20"
        },
        {
          value: "Transportation",
          show: "Transportation(TPT)",
          flex: "20"
        },

        {
          value: "All",
          show: "All",
          flex: "15"
        }
        // {
        //   value: "None",
        //   show: "None",
        //   flex: "15"
        // },
      ];
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.mx-datepicker-popup {
position: unset;
}
</style>


// WEBPACK FOOTER //
// fclConsoHandOverToRail.vue?19c6cee7